import React, { useEffect } from 'react';
import { CircularProgress, IconButton, makeStyles, Paper, Typography } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import allActions from '../../../actions';
import { StatusDpinDairAPI } from '../../../API/status_dpin_dair';
import { unoTheme } from '../../../assets/styles/unoTheme';
import MyTable from '../../utils/MyTable';
import MyTextField from '../../utils/MyTextField';
import UnoButton from '../../utils/UnoButton';
import { getMonthName } from '../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',

    '& .MuiTableContainer-root': {
      height: 'calc(100vh - 103px) !important',
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    backgroundColor: unoTheme.hoverTable,
  },
  leftHeader: {
    display: 'flex',
    flexDirection: 'column',
  },
  fundLabel: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1C2228'
  },
  accountLabel: {
    fontSize: '14px',
    color: unoTheme.secondaryColor,
  },
  sectionLabel: {
    fontWeight: 'bold',
    color: unoTheme.mainColor,
    background: unoTheme.hoverTable,
  },
  addCommentLabel: {
    cursor: "pointer",
    color: unoTheme.defaultTextColor,

    '&:hover': {
      color: unoTheme.mainColor,
    }
  },
  rightDivBackdrop: {
    zIndex: 3,
    backgroundColor: 'white',
    position: 'absolute',
    opacity: 0.85,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    color: unoTheme.mainColor,
    alignItems: 'center',
    justifyContent: 'center',

    '& .progress': {
      color: unoTheme.mainColor
    }
  },
}));


export default function StatusesClientHistoricXmlAudesp({ content }) {
  const dispatch = useDispatch();

  const {
    data: { year, clientId }
  } = content;

  const classes = useStyles();

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [historicData, setHistoricData] = useState(null);

  const loadHistoric = async (year, cllientId) => {

    const response = await StatusDpinDairAPI.getStatusXmlAudespHistoricByClientId(year, cllientId);
    if (response.success) {
      setHistoricData(response.body);
      setOpenBackdrop(false);
    }

  }

  useEffect(() => {
    if (!year || !clientId) return;
    loadHistoric(year, clientId);
  }, [year, clientId])

  //Chave composta type-id (evita colisão entre ids de mês e de trimestre)
  const [openTextCommentArea, setOpenTextCommentArea] = useState();
  const [theComment, setTheComment] = useState("");

  const doSaveComment = async (type, recordId, userId) => {

    const comment = theComment;
    if (comment.length > 2048) {
      dispatch(allActions.mainAlertActions.setMainAlert({
        show: true,
        type: "warning",
        message: "O comentário excedeu o limite de caracteres!"
      }))
    } else {
      setOpenBackdrop(true);
      const responseSave = type === 'tri'
        ? await StatusDpinDairAPI.saveCommentXmlAudespTri(recordId, userId, comment)
        : await StatusDpinDairAPI.saveCommentXmlAudesp(recordId, userId, comment);
      if (responseSave.success) {
        handleComment(null, null);
        await loadHistoric(year, clientId);
      } else {
        setOpenBackdrop(false);
      }
    }
  }

  const handleComment = (compositeKey, comment) => {
    setTheComment(comment);
    setOpenTextCommentArea(compositeKey);
  }

  const getCommentCell = (element, type) => {
    const { comment, id, user_id } = element;
    const compositeKey = type + '-' + id;
    const isEditting = compositeKey === openTextCommentArea;

    if (isEditting) {
      return (
        <div>

          <MyTextField
            value={theComment}
            onChange={(value) => {
              setTheComment(value)
            }}
            multiline={true}
            rows={5}
            rowsMax={5}
            fullWidth />

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

            <UnoButton
              size="verySmall"
              onClick={() => handleComment(null, null)}
              type={'defaultClean'}>
              {"Cancelar"}
            </UnoButton>

            <UnoButton
              size="verySmall"
              onClick={() => doSaveComment(type, id, user_id)}
              type='primary'>
              {"Salvar"}
            </UnoButton>
          </div>
        </div>
      )
    } else {

      if (comment) {
        return (<div>{comment}</div>)
      } else {
        return (<Typography variant={"body1"} className={classes.addCommentLabel} onClick={() => handleComment(compositeKey, comment)}>+ Adicionar comentário</Typography>)
      }

    }

  }

  //Monta as linhas de uma seção (mensal ou trimestral) agrupando por período
  const renderSection = (sectionTitle, data, type, getGroupKey, getGroupLabel) => {
    const nodes = [];
    if (!data || !data.length) return nodes;

    nodes.push(
      <TableHead key={'section-' + type}>
        <TableRow>
          <TableCell align="left" colSpan={4} className={classes.sectionLabel}>{sectionTitle}</TableCell>
        </TableRow>
      </TableHead>
    )

    const includedGroups = [];
    data.forEach(element => {
      const groupKey = getGroupKey(element);

      if (!includedGroups.includes(groupKey)) {
        includedGroups.push(groupKey)

        nodes.push(
          <TableHead key={'group-' + type + '-' + groupKey}>
            <TableRow>
              <TableCell align="left" colSpan={3}>{getGroupLabel(groupKey)}</TableCell>
            </TableRow>
          </TableHead>
        )

        const rowsInGroup = data.filter(el => getGroupKey(el) === groupKey);

        nodes.push(
          <TableBody key={'group-body-' + type + '-' + groupKey}>
            {
              rowsInGroup.map((elementInGroup, index) => (
                <TableRow key={'row-' + type + '-' + elementInGroup.id + '-' + index}>
                  <TableCell align="center">{moment.utc(elementInGroup.created_date).format("DD/MM/YYYY")}</TableCell>
                  <TableCell align="left" style={{ color: elementInGroup.color }}>{elementInGroup.status_name}</TableCell>
                  <TableCell align="left">
                    {getCommentCell(elementInGroup, type)}
                  </TableCell>
                  <TableCell align="left" className="noPaddingCell">
                    <IconButton className={classes.addCommentLabel} style={{ visibility: elementInGroup.comment ? "visible" : "hidden" }} onClick={() => handleComment(type + '-' + elementInGroup.id, elementInGroup.comment)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        )
      }
    });

    return nodes;
  }

  const renderedHistoric = useMemo(() => {
    if (!historicData) return [];

    const monthNodes = renderSection(
      'Status mensais',
      historicData.months,
      'month',
      (el) => el.month,
      (groupKey) => getMonthName(groupKey)
    );

    const quarterNodes = renderSection(
      'Status trimestrais',
      historicData.quarters,
      'tri',
      (el) => el.tri,
      (groupKey) => groupKey + 'º Trimestre'
    );

    return [...monthNodes, ...quarterNodes];
  }, [historicData, openTextCommentArea, theComment])

  return (
    <div className={classes.root}>

      <Paper style={{ marginBottom: '4px' }}>
        <div className={classes.header}>
          <div className={classes.leftHeader}>
            <div>
              <Typography
                align={'left'}
                className={classes.fundLabel}>
                Histórico de Status XML - AUDESP
              </Typography>
              <Typography
                align={'left'}
                className={classes.accountLabel}>
                <span>Ano:
                  <Typography component="strong" style={{ color: unoTheme.mainColor, marginLeft: "8px" }}>{year}</Typography>
                </span>

              </Typography>
            </div>
          </div>

          <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
            <CloseIcon />
          </IconButton>

        </div>
      </Paper>
      <MyTable
        stickyHeader
        nofixed={true}
        size="small">
        <colgroup>
          <col width="12.5%" />
          <col width="37.5%" />
          <col width="45%" />
          <col width="5%" />
        </colgroup>
        {renderedHistoric}
      </MyTable>

      {
        openBackdrop ?
          <div className={classes.rightDivBackdrop}>
            <CircularProgress className={'progress'} />
            <Typography variant={'body1'} style={{ marginTop: '16px' }}>
              Atualizando...
            </Typography>

          </div> : null
      }
    </div>
  )
}
